/**
 * Turkish date helpers.
 * Panel data is stored as ISO YYYY-MM-DD; UI everywhere shows GG.AA.YYYY
 * (gün.ay.yıl) — Turkish convention.
 */

/** Format ISO YYYY-MM-DD → "GG.AA.YYYY". Returns empty string for empty/invalid. */
export function formatTr(iso) {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso; // If already non-ISO (e.g. dd.mm.yyyy) just pass through
  return `${m[3]}.${m[2]}.${m[1]}`;
}

/** Format ISO YYYY-MM-DD → "GG.AA.YY" (compact). */
export function formatTrShort(iso) {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}.${m[2]}.${m[1].slice(2)}`;
}

/** Format ISO datetime (with time) → "GG.AA.YYYY SS:DD". */
export function formatTrDateTime(iso) {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (!m) return formatTr(iso);
  return `${m[3]}.${m[2]}.${m[1]} ${m[4]}:${m[5]}`;
}
